export const gtagEvent = (action, params) => {
    if (typeof window !== 'undefined' && window.gtag) {
        console.log('gtagEvent called with action:', action, 'and params:', params)
        window.gtag('event', action, params)
    } else {
        console.warn('gtag not found')
    }
}

export const setUserId = (userId) => {
    if (typeof window !== 'undefined' && window.gtag) {
        console.log(userId, 'dedededuserid')
        window.gtag('set', { user_id: userId })
    }
}

const normalizeEmail = (email) => (typeof email === 'string' ? email.trim().toLowerCase() : '')

// Numbers without a country code are assumed to be US (+1).
const normalizePhone = (phone) => {
    if (typeof phone !== 'string') return ''
    const digits = phone.replace(/\D/g, '')
    if (!digits) return ''
    return digits.length === 10 ? `+1${digits}` : `+${digits}`
}

// gtag hashes plain-text user data before sending it to Google.
export const setUserData = (email, phone) => {
    if (typeof window === 'undefined' || !window.gtag) return

    const userData = {}
    const normalizedEmail = normalizeEmail(email)
    const normalizedPhone = normalizePhone(phone)
    if (normalizedEmail) userData.email = normalizedEmail
    if (normalizedPhone) userData.phone_number = normalizedPhone

    if (Object.keys(userData).length) {
        window.gtag('set', 'user_data', userData)
    }
}
